import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import { useNavigate, useParams, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "assets/theme/admin_form.css";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile: "",
    role_id: "",
    party_id: "",
    ward_id: ""
  });

  const [roles, setRoles] = useState([]);
  const [parties, setParties] = useState([]);
  const [wards, setWards] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDropdowns();
    fetchUser();
  }, []);

  const fetchDropdowns = async () => {
    const rolesRes = await apiFetch("super_admin/list_roles");
    const partiesRes = await apiFetch("super_admin/list_parties");
    const wardsRes = await apiFetch("super_admin/list_ward");

    setRoles(rolesRes.roles || rolesRes);
    setParties(partiesRes.parties || partiesRes);
    setWards(wardsRes.wards || wardsRes);
  };

  const fetchUser = async () => {
    const res = await apiFetch(`super_admin/get_user_by_id/${id}`);
    setFormData(res.user || res);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await apiFetch(`super_admin/edit_user/${id}`, {
        method: "PUT",
        body: JSON.stringify(formData),
      });

      alert("User updated successfully");
      navigate("/users");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
      <DashboardLayout>
      <DashboardNavbar />
    <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

      {/* Header Card */}
      <div className="admin-form-header-card">
        <div className="d-flex align-items-center gap-3">
          <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
            <FaArrowLeft />
            <span>मागे जा (Back)</span>
          </button>
          <div>
            <h4 className="fw-bold mb-1 text-white">
              ✏️ वापरकर्ता संपादित करा (Edit User)
            </h4>
            <small className="text-white-50">
              Update user information and access
            </small>
          </div>
        </div>

        <Link to="/users" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
          User List
        </Link>
      </div>

      {/* Card */}
      <div className="card shadow-sm">
        <div className="card-body">

          <form onSubmit={handleSubmit}>
            <div className="row g-4">

              {/* Personal Info */}
              <div className="col-12">
                <h6 className="text-primary mb-2" style={{ fontSize: "0.95rem" }}>Personal Information</h6>
                <hr className="mt-0" />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  disabled
                />
                <small className="text-muted">
                  Email cannot be changed
                </small>
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                />
              </div>

              {/* Role Info */}
              <div className="col-12 mt-3">
                <h6 className="text-primary mb-2" style={{ fontSize: "0.95rem" }}>Role & Assignment</h6>
                <hr className="mt-0" />
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Role</label>
               <select
  className="form-select"
  name="role_id"
  value={formData.role_id || ""}
  onChange={handleChange}
  required
>
  <option value="">Select Role</option>

  {roles.map((r) => (
    <option key={r.role_id} value={r.role_id}>
      {r.role_name}
    </option>
  ))}
</select>


              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Party</label>
                <select
                  className="form-select"
                  name="party_id"
                  value={formData.party_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Party</option>
                  {parties.map((p) => (
                    <option key={p.party_id} value={p.party_id}>
                      {p.party_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Ward</label>
                <select
                  className="form-select"
                  name="ward_id"
                  value={formData.ward_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Ward</option>
                  {wards.map((w) => (
                    <option key={w.ward_id} value={w.ward_id}>
                      {w.ward_name}
                    </option>
                  ))}
                </select>
              </div>


            </div>

            {/* Footer */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => window.location.href = "/users"}
                style={{ fontSize: "0.85rem" }}
              >
                Cancel
              </button>

              <button className="btn btn-primary px-4" disabled={loading} style={{ fontSize: "0.85rem" }}>
                {loading ? "Updating..." : "Update User"}
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
      </DashboardLayout>
  );
};

export default EditUser;
